module.exports = __webpack_public_path__ + "static/media/email-saved-template1.16ae4719.png";